import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useTranslation } from 'react-i18next'
import { HiArrowLeft } from 'react-icons/hi'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbTriple } from '../../utils/seoUtils'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import ustavMarkdown from '../../content/documents/Ustav_SUMA_redaktsiya_2026.md?raw'
import './Charter.css'

const markdownComponents = {
  table: ({ children, ...props }) => (
    <div className="charter-table-scroll">
      <table {...props}>{children}</table>
    </div>
  ),
}

function Charter() {
  const { t } = useTranslation()
  const getLocalizedLink = useLocalizedLink()

  const breadcrumbItems = useMemo(
    () =>
      seoBreadcrumbTriple(
        t('common.home'),
        t('common.documents'),
        'documents',
        t('documents.charterPage.breadcrumb'),
        'documents/charter'
      ),
    [t]
  )

  return (
    <div className="charter-page">
      <SEO
        title={t('documents.charterPage.title')}
        description={t('documents.charterPage.description')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container charter-container">
        <Link to={getLocalizedLink('/documents')} className="charter-back-link">
          <HiArrowLeft aria-hidden />
          {t('documents.charterPage.back')}
        </Link>

        <article className="charter-document">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
            {ustavMarkdown}
          </ReactMarkdown>
        </article>
      </div>
    </div>
  )
}

export default Charter
